export default "__VITE_ASSET__CNTzp_a5__"